import { render, staticRenderFns } from "./listCheck.vue?vue&type=template&id=bd055db4&scoped=true&"
import script from "./listCheck.vue?vue&type=script&lang=js&"
export * from "./listCheck.vue?vue&type=script&lang=js&"
import style0 from "./listCheck.vue?vue&type=style&index=0&id=bd055db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd055db4",
  null
  
)

export default component.exports